(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-banner-mini"] && !Shopify.designMode) return;
  try {
    
  const slideLength = document.querySelectorAll('.swiper .swiper-slide').length;
  const initSwiper = () => {
    const mySwiper = new Swiper('.swiper', {
      

      loop: true,
      loopedSlides: slideLength,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      grabCursor: true,
      spaceBetween: 8,
      slidesPerView: 1,
      breakpoints: {
        460: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 16,          
        }
      },
      on: {
        touchEnd: (swiper) => {
          swiper.slideTo(swiper.activeIndex + 1);
        }
      }
    });
  };

  window.addEventListener('load', function(){
    initSwiper();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    

class Slider {
  AUTO_SLIDE_INTERVAL = 5000; // ms
  constructor() {
    this.slides = [...document.getElementsByClassName('banner-item')]
    this.dots = [...document.getElementsByClassName('dot-button')]
    this.nextButton = document.getElementById('arrow-button-next')
    this.prevButton = document.getElementById('arrow-button-prev')
    this.init()
  }
  init() {
    // bind events
    this.dots.forEach((d, index) => this.bindClick(d, () => this.slideByIndex(index)))
    this.bindClick(this.nextButton, () => this.next())
    this.bindClick(this.prevButton, () => this.prev())

    // init state
    this.slideByIndex(0, true)
  }
  next() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length
    this.slideByIndex(nextIndex)
  }
  prev() {
    const prevIndex = (this.slides.length + this.currentIndex - 1) % this.slides.length
    this.slideByIndex(prevIndex)
  }
  slideByIndex(index, firstTime = false) {
    this.updateSlide(index);
    this.updateDot(index);
    this.setNextAutoSlide();
    if(firstTime) {
      this.startLoader(firstTime);
    }
    else {
      this.updateLoader(firstTime);
    }
    this.currentIndex = index
  }

  bindClick(target, callback) {
    target.addEventListener('click', callback)
    target.addEventListener('tap', callback)
  }
  updateSlide(index) {
    const inner = document.getElementById('banner-container-inner')
    inner.style.transform = `translateX(${index * -100 / this.slides.length }%)`
  }
  updateDot(index) {
    const currentDot = this.dots.find(d => d.classList.contains('is-active'))
    if(currentDot) {
      currentDot?.classList.remove('is-active')
    }
    const nextDot = this.dots[index].classList.add('is-active')
  }
  startLoader() {
    const circle = document.getElementById('fill-circle');
    circle.classList.add('in-progress');
  }
  updateLoader() {
    const circle = document.getElementById('fill-circle')
    circle.classList.remove('init');
    circle.classList.remove('in-progress')
    circle.classList.add('filled')
    circle.addEventListener('transitionend', () => {
      circle.classList.remove('filled');
      void circle.offsetWidth;
      setTimeout(() => circle.classList.add('in-progress'));
    }, { once: true })
  }
  setNextAutoSlide() {
    if(this.timeoutId) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    this.timeoutId = window.setTimeout(() => {
      this.timeoutId = null
      this.next();
    }, this.AUTO_SLIDE_INTERVAL)
  }
}
new Slider()

  } catch(e) { console.error(e); }
})();
})();
